<template>
    <div class="mt-5">
        <errors-alert :errors="errors"></errors-alert>
        <errors-alert v-if="typeof errorMessagesList !== 'undefined' && (typeof errorMessagesList === 'object' && errorMessagesList.length!==0 && errors.length===0)" :errors="errorMessagesList"></errors-alert>
        <v-btn
            v-if="backButton"
            color="secondary"
            :disabled="$store.state.config.stepLoading"
            @click="$emit('step-back')"
        >
            {{ backButton === true ? 'Back' : nextButton }}
        </v-btn>
        <v-btn
            v-if="nextButton"
            color="primary"
            :loading="$store.state.config.stepLoading"
            :disabled="disabled_status"
            @click="$emit('step-next')"
        >
            {{ nextButton === true ? 'Continue' : nextButton }}
        </v-btn>
    </div>
</template>

<script>
import ErrorsAlert from "./ErrorsAlert";
import {mapGetters} from "vuex";

export default {
    name      : "StepsNavigation",
    components: {ErrorsAlert},
    props     : {
        'errors'    : null,
        'errorMessagesList'    : {type: Array, default: () => []},
        'nextButton': {default: true},
        'backButton': {default: true},
        'backForce' : {default: true}
    },
    computed  : {
        ...mapGetters(['disabled_status'])
    }
}
</script>

<style scoped>

</style>
